import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import AppliancesSvg from '../../../assets/icons/app/appliances.svg?raw';

export const AppliancesIcon = (props) => <CustomSVG svg={AppliancesSvg} preserveColors appIconSmall {...props} />;
